// Node Module Imports
import React from 'react'

import PropTypes from 'prop-types'

const YouTubeEmbed = ({
  autoplay, className, height, style, title, videoId, width,
}) => {
  videoId = videoId.replace('https://www.youtube.com/embed/', '')

  return (
    <div className="video-wrapper">
      <iframe
        className={className}
        width={width}
        height={height}
        src={`https://www.youtube.com/embed/${videoId}?controls=1&modestbranding=1&rel=0${autoplay ? '&autoplay=1' : ''}`}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title}
        style={style} />
    </div>
  )
}

YouTubeEmbed.propTypes = {
  autoplay: PropTypes.bool,
  className: PropTypes.string,
  height: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  style: PropTypes.object,
  title: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
}

YouTubeEmbed.defaultProps = {
  autoplay: false,
  height: 'auto',
  width: 'auto',
}

export default YouTubeEmbed
